import { Sld } from '../data/sld';

export class StacAsset {
    // Data retrieved from STAC data
    public key: string;
    public href: string;
    public title: string|undefined;
    public description: string|undefined;
    public type: string|undefined;
    public roles: string[] = [];
    public properties: any = {};
    public collection: string|undefined; // The STAC collection identifier
    public bbox: [number]|undefined;

    // Data retrieved from S3 bucket storage:
    public size: string|undefined;
    public lastmodified: string|undefined;

    // WMS server URL for the asset, e.g.
    // https://geoserver.dev.f-tep.com/geoserver-cloud/463010c0-0723-11f1-991f-6a8672cac7fb_myfile_tif_GdalWarp_1770798406066147921_myfile.tif/wms
    wmsUrl: string|undefined;
    // WMS layer name, e.g.
    // 463010c0-0723-11f1-991f-6a8672cac7fb_myfile_tif_GdalWarp_1770798406066147921_myfile.tif:myfile.tif
    wmsLayerName: string|undefined; 
    // The Openlayers map layer object (when the layer is visible)
    wmsMapLayer: any|undefined;
    // SLD definition
    sld: Sld|undefined;
    defaultSld: Sld|undefined;
    // opacity
    wmsopacity: number|undefined;

    constructor(key:string, href:string) {
        this.key = key;
        this.href = href;
    }

    static parse(key:string, collection:string|undefined, data:any, s3data:any, s3bucket:string|undefined): StacAsset|null {
        if ('href' in data) {
            let asset = new StacAsset(key, data.href);
            asset.title = data.title;
            if (!asset.title) {
                asset.title = new URL(asset.href).pathname.split('/').pop();
            }
            asset.description = data.description;
            asset.type = data.type;
            asset.roles = data.roles;
            asset.collection = collection;
            // Combine with S3 file data
            //console.log(data);
            if (s3data && s3bucket) {
                for (let file of s3data) {
                    if (asset.href == 's3://' + s3bucket + '/' + file.key) {
                        asset.size = file.size;
                        asset.lastmodified = file.lastmodified;
                    }
                }
            }

            // parse additional properties
            const fixedkeys = ['href','title','description','type','roles','default_style'];
            for (const [key, value] of Object.entries(data)) {
                if (!fixedkeys.includes(key)) {
                    asset.properties[key] = value;
                } else if (key == 'default_style') {
                    asset.defaultSld = Sld.fromJson(JSON.parse(String(value)));
                    asset.sld = Sld.fromJson(JSON.parse(String(value)));
                }
                //console.log(`${key}: ${value}`);
            }
            return asset;
        }
        return null;
    }
}
